module.exports = __webpack_public_path__ + "static/media/_insigne.5ea87318.jpg";